import type { EnvironmentConfig } from '../environments/interfaces.ts';

//console.log("appEnv:", import.meta.env.VITE_APP_ENV);
const appEnv = import.meta.env.VITE_APP_ENV || 'localdev' ;

let envConfigPromise: Promise<{ environment: EnvironmentConfig }>;

switch (appEnv) {
  case 'test':
    envConfigPromise = import('../environments/environment.qa.ts');
    break;
  case 'prod':
    envConfigPromise = import('../environments/environment.production.ts');
    break;
  case 'rel':
    envConfigPromise = import('../environments/environment.rel.ts');
    break;
  case 'dev':
  default:
    envConfigPromise = import('../environments/environment.localdev.ts');
    break;
}

export const environment: EnvironmentConfig = await envConfigPromise.then(
  (mod) => mod.environment
);

